'use client';

import {
  AttributeSide,
  AttributeSideDynamic,
} from '@eliadmin/core/src/components/categories/attributes/attribute';
import { AttributeCategory } from '@eliadmin/core/src/components/categories/attributes/attribute-category';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { Card } from '@eliadmin/core/src/components/ui/card';
import { Separator } from '@eliadmin/core/src/components/ui/separator';
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetTrigger,
} from '@eliadmin/core/src/components/ui/sheet';
import { CATEGORY_CONFIG } from '@eliadmin/core/src/constants/category-config';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useCategoryStore } from '@eliadmin/core/src/stores/category-store';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { FiArrowLeft } from 'react-icons/fi';
import { IoClose } from 'react-icons/io5';
import { TbCategoryPlus } from 'react-icons/tb';
import { TfiBrushAlt } from 'react-icons/tfi';

const FilterSeparator = () => <Separator className="mx-4 w-auto last-of-type:hidden" />;

export function CategoryFilterSheet() {
  const templateSettings = useGlobalStore(state => state.templateSettings);
  const categoryTree = useCategoryStore(state => state.categoryTree);
  const category = useCategoryStore(state => state.category);
  const { t } = useTranslations();
  const clearFilter = useCategoryStore(s => s.clearFilters);

  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button
          variant={'outline'}
          className="flex w-full items-center justify-center gap-2 !text-lg font-medium uppercase"
        >
          <TbCategoryPlus size={20} /> {t('text174')}
        </Button>
      </SheetTrigger>
      <SheetContent className="w-full px-0 py-0" showCloseIcon={false}>
        <Card
          className={cn(
            'relative h-screen max-h-screen overflow-auto bg-background',
            'ea-category-filter-sheet',
          )}
        >
          <div
            className={cn(
              'flex w-full flex-row items-center justify-between px-4 pb-5 pt-4',
              'ea-category-filter-sheet__expand-button',
            )}
          >
            <h3 className="text-2xl font-medium uppercase text-foreground">{t('text174')}</h3>
            <SheetClose asChild>
              <IoClose size={24} className="text-foreground" />
            </SheetClose>
          </div>
          <FilterSeparator />
          <div className={cn('mt-4 flex flex-col gap-4', 'ea-category-filter-sheet__content')}>
            {/* attributes */}
            {!!templateSettings.category?.attributes_in_filter?.enabled && (
              // <div className={`order-${templateSettings.category.attributes_in_filter.order}`}>
              <>
                {category.attributes?.map((attribute, i) => (
                  <>
                    <AttributeSideDynamic
                      key={`attribute-${attribute.id ?? attribute.name}-${i}`}
                      name={attribute.name === t('text175') ? t('text785') : attribute.name}
                      attribute={attribute as any}
                      className={{ wrapper: cn('', 'ea-category-filter-sheet__attributes') }}
                    />
                    <FilterSeparator />
                  </>
                ))}
              </>
            )}
            {/* <FilterSeparator />
            {/* categories */}
            {/* {!!templateSettings.category?.tree_list?.enabled && !!categoryTree && (
              <AttributeCategory order={templateSettings.category.tree_list.order} />
            )} */}

            {/* <FilterSeparator /> */}

            {/* subcategories */}
            {/* {!!templateSettings.category?.categories_in_filter?.enabled &&
              !!category.sub_categories?.length && (
                <>
                  <AttributeSide
                    name={t('text337')}
                    type="subCategory"
                    attribute={{ type: 'status', type2: 'statuses' }}
                    order={templateSettings.category.categories_in_filter.order}
                    className={{ wrapper: cn('', 'ea-category-filter-sheet__subcategories') }}
                  />
                  <FilterSeparator />
                </>
              )} */}

            {/* manufacturers */}
            {/* {!!templateSettings.category?.manufacturers_in_filter?.enabled &&
              !!category.manufacturers?.length && (
                <>
                  <AttributeSide
                    name={t('text195')}
                    type="generic"
                    attribute={{ type: 'manufacturer', type2: 'manufacturers' }}
                    order={templateSettings.category.manufacturers_in_filter.order}
                    className={{ wrapper: cn('', 'ea-category-filter-sheet__manufacturers') }}
                  />
                  <FilterSeparator />
                </>
              )} */}

            {/* statuses */}
            {/* {!!templateSettings.category?.statuses_in_filter?.enabled &&
              !!category.statuses?.length && (
                <>
                  <AttributeSide
                    name={t('text518')}
                    type="generic"
                    attribute={{ type: 'status', type2: 'statuses' }}
                    order={templateSettings.category?.categories_in_filter?.order}
                    className={{ wrapper: cn('', 'ea-category-filter-sheet__statuses') }}
                  />
                  <FilterSeparator />
                </>
              )} */}

            {/* availabilities */}
            {/* {!!templateSettings.category?.availability_in_filter?.enabled &&
              !!category.availabilities?.length && (
                <>
                  <AttributeSide
                    name={t('text339')}
                    type="generic"
                    attribute={{ type: 'availability', type2: 'availabilities' }}
                    order={templateSettings.category.availability_in_filter.order}
                    className={{ wrapper: cn('', 'ea-category-filter-sheet__availabilities') }}
                  />
                  <FilterSeparator />
                </>
              )} */}

            {/* price */}
            {/* {!!templateSettings.category?.price_in_filter?.enabled && (
              <>
                <AttributeSide
                  name={t('text340')}
                  type="price"
                  attribute={{ type: 'status', type2: 'statuses' }}
                  order={templateSettings.category.price_in_filter.order}
                  className={{ wrapper: cn('', 'ea-category-filter-sheet__price') }}
                />
                <FilterSeparator />
              </>
            )} */}
            {/* 
            {!!templateSettings.category?.suppliers_in_filter?.enabled && (
              <>
                <AttributeSide
                  name={t('text718')}
                  type="generic"
                  attribute={{ type: 'supplier', type2: 'suppliers' }}
                  className={{ wrapper: cn('', 'ea-category-filter-sheet__suppliers') }}
                  order={templateSettings.category.suppliers_in_filter.order}
                />
                <FilterSeparator />
              </>
            )}
            {!!templateSettings.category?.suppliers_location_in_filter?.enabled && (
              <>
                <AttributeSide
                  name={t('text728')}
                  type="supplierLocation"
                  attribute={{ type: 'supplier', type2: 'suppliers' }}
                  className={{ wrapper: cn('', 'ea-category-filter-sheet__suppliers_location') }}
                  order={templateSettings.category?.suppliers_in_filter?.order}
                />
                <FilterSeparator />
              </>
            )} */}
          </div>

          <div className="sticky bottom-0 flex flex-1 flex-col justify-end gap-2 pb-2">
            <Separator />
            <div className="flex w-full items-center justify-between gap-3.5 p-3.5">
              <SheetClose asChild>
                <Button className="w-full">{t('text1380')}</Button>
              </SheetClose>
              <SheetClose
                onClick={clearFilter}
                className="flex min-h-12 min-w-12 items-center justify-center border border-primary text-primary"
              >
                <TfiBrushAlt size={20} />
              </SheetClose>
            </div>
          </div>
        </Card>
      </SheetContent>
    </Sheet>
  );
}
